<!--
 * @Author: Alfred huqitaoit@gmail.com
 * @Date: 2023-12-15 14:43:28
 * @LastEditors: Alfred
 * @LastEditTime: 2023-12-15 15:07:20
 * @Description:
 * @FilePath: \src\components\order\OrderRefundAuditDetail.vue
-->
<template>
  <div class="order-refund-detail">

    <div class="tuolele-main-box">
      <el-table :data="orderLists" border stripe>
        <el-table-column prop="id" label="ID" />

        <el-table-column prop="create_time" label="创建时间" />
        <el-table-column prop="company_name" label="公司" />
        <el-table-column prop="remark" label="转账备注" />
        <el-table-column prop="company_name" label="金额">
          <template slot-scope="scope">
            <span>{{ scope.row.amount/100 }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="classify_name" label="类型" />

        <el-table-column label="审核操作">
          <template slot-scope="scope">
            <el-button size="small" type="success" @click="auditOrder(scope.row)">审核订单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px;"
        layout="prev, pager, next, slot, jumper"
        :current-page.sync="listQuery.page"
        prev-text="上一页"
        next-text="下一页"
        :total="listQuery.total"
        :page-size="listQuery.limit"
        @current-change="getRefundList"
      >
        <div class="chax">
          {{ listQuery.page }}/{{ listQuery.total > 0 ? Math.ceil(listQuery.total / listQuery.limit) : 1 }}
        </div>
      </el-pagination>
    </div>
    <el-dialog
      title="订单详情"
      :visible.sync="dialogVisible1"
      width="500px"
      class="order-detail-dialog"
    >
      <el-image v-if="currentOrder.voucher" :preview-src-list="[currentOrder.voucher]" :src="currentOrder.voucher" alt="" style="width: 320px ;height: 400px;" />
      <el-input v-model="currentOrder.remark" placeholder="备注信息" />
      <div slot="footer" class="dialog-footer">
        <el-button type="warning" @click="auditFailed()">凭证错误需重新上传</el-button>
        <el-button type="primary" @click="auditSuccess()">审核成功</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'OrderRefundAuditDetail',
  props: {
    search: Object
  },
  data() {
    return {
      listQuery: {
        status: '',
        page: 0,
        total: 0,
        limit: 20
      },
      dialogVisible1: false,
      orderLists: [],
      currentOrder: {}
    }
  },
  watch: {
    search: {
      deep: true,
      handler(newVal) {
        console.log(newVal)
        this.listQuery = Object.assign({}, this.listQuery, newVal)
        this.getRefundList()
      }
    }
  },
  mounted() {
    this.getRefundList()
  },
  methods: {

    getRefundList() {
      this.dialogVisible1 = false
      this.$http.getTgbOrderAuditList(this.listQuery).then(res => {
        this.orderLists = res.data.list
        this.listQuery.total = parseInt(res.data.count)
      })
    },
    auditOrder(row) {
      this.currentOrder = row
      this.dialogVisible1 = true
    },
    auditSuccess() {
      this.$http.auditTgbOrder({
        status: 2,
        order_id: this.currentOrder.id,
        remark: this.currentOrder.remark || ''
      }).then(res => {
        this.getRefundList()
      })
    },
    auditFailed() {
      this.$http.auditTgbOrder({
        status: 3,
        order_id: this.currentOrder.id,
        remark: this.currentOrder.remark || '凭证错误需要重新上传'
      }).then(res => {
        this.getRefundList()
      })
    }

  }
}
</script>

<style lang="scss">
.order-refund-detail {
  .export-btn {
    margin: 0 40px;
  }
  .flex-con {
    margin-right: 30px;
  }
  .flex-con:last-child {
    margin-right: 0;
  }
  .order-count {
    height: 160px;
    color: #fff;
    padding: 30px 0 0 30px;
    margin: 0 auto;
    background: url(../../assets/img/price-bg.png) #4c84ff right bottom
      no-repeat;
    background-size: 96px 117px;
    border-radius: 10px;
    span {
      font-size: 20px;
      margin-bottom: 25px;
    }
    p {
      font-size: 40px;
    }
  }
  .table-header {
    margin-bottom: 20px;
  }
  .el-table td {
    border: 1px solid #f5f5f5;
  }
  .refund-bill-list {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f5f5f5;
    div {
      margin-bottom: 10px;
      font-weight: bold;
    }
  }
  .order-img .el-dialog {
    height: 95% !important;
    .el-dialog__body {
      height: 90%;
    }
    .agreement_picture,
    .pdf {
      height: 100%;
    }
  }
}
</style>
